module.exports = __webpack_public_path__ + "img/cel-infocupo.b096fdde.svg";